import React,{useContext,useEffect,useState} from 'react';
import './Preloader.css';
import SimpleContext from '../context/SimpleContext';


const Preloader = ({type}) => {
    const context = useContext(SimpleContext);
    const bgColor= context.theme.backgroundColor
    const dot = {
        margin: "auto",
        color:bgColor,
        width:"60px",
        height:'40px',
        "--d":'radial-gradient(farthest-side,currentColor 90%,#0000)',
        background:"var(--d),var(--d),var(--d)",
        backgroundSize:'20px 20px',
        backgroundRepeat:'no-repeat',
        animation:' m 1s infinite alternate',
    }
              
    return ( 

             <div style={{width:"100%", height:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"flex-end"}}>
    
              <div  className="dot2" ></div>
               
             </div> 

     );
}
 
export default Preloader;